
import React from 'react';

import { getToken, utc_local } from '../../../helpers/Helper';
import { POST_USER_INVOICE_LIST, POST_PDF_INVOICE } from '../../../helpers/url_helper';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import { useNavigate } from 'react-router-dom';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";

import { useTranslation } from 'react-i18next';

const UserRoles = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    useMounted(() => {
        get_invoice_list()
    })

    const get_invoice_list = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [5] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_USER_INVOICE_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "invoiceId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.createdAt)}
                            </>)
                        }
                    },
                    { "data": "name" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                ₹ {data.totalAmount}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.paymentStatus === 'Unpaid' && <span className='text-danger'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Paid' && <span className='text-success'>{data.paymentStatus}</span>}
                                {data.paymentStatus === 'Canceled' && <span className='text-danger'>{data.paymentStatus}</span>}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.paymentStatus === 'Paid' && <>
                                    <a href={`${POST_PDF_INVOICE}${data.invoiceId}`} target="_blank" rel="noreferrer" className={`btn btn-sm text-info`}><i className="bx bxs-file-pdf"></i></a>
                                </>}
                                {data.paymentStatus === 'Unpaid' && 
                                    <button  onClick={() => { navigate('/invoices/pay/' + data.invoiceId); }} className='btn btn-sm btn-success'>Pay</button>
                                }
                            </>)
                        }
                    },

                ]
            });
        }
    }


    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>{t('invoices.invoices')} </h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />

                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>{t('invoices.invoiceNo')}</td>
                                            <td>{t('invoices.invoiceDate')}</td>
                                            <td>{t('invoices.planName')}</td>
                                            <td>{t('invoices.totalAmount')}</td>
                                            <td>{t('invoices.status')}</td>
                                            <td>{t('invoices.action')}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserRoles;